// In TableLists.js
import React, { useState } from "react";
import { TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import eye from "../../../assets/DigitalMarketing/image/visibility.svg";
import IosSwitchBtn from "../../../Component/DigitalMarketing/IosSwitchbtn";
import { formatDate } from "../Utils/utils";

type TableListsProps = {
  searchValue: string;
  order: "asc" | "desc";
  orderBy: string;
  patientListData: Array<any>; // Add patientListData as a prop
};

const TableLists: React.FC<TableListsProps> = ({
  searchValue,
  order,
  orderBy,
  patientListData,
}) => {
  const [checkedStates, setCheckedStates] = useState<boolean[]>([]);
  const navigate = useNavigate();
  const handleView = (id: any) => {
    navigate(`patient-details/${id}`);
  };

  const deleteBranches = (confirm: boolean, id: number) => {
    if (confirm) {
      console.log("Deleted item with id:", id);
    }
  };

  return (
    <>
      {patientListData.map((c, index) => (
        <TableRow key={c.customersId} role="checkbox">
          <TableCell align="left">{index + 1}</TableCell>
          <TableCell align="left">{c.customerName}</TableCell>
          <TableCell align="left">{c.caseId}</TableCell>
          <TableCell align="left">{c.consultantName}</TableCell>
          <TableCell align="left">{c.phone1}</TableCell>
          <TableCell align="left">{c.city}</TableCell>
          <TableCell align="left" className="text-nowrap">
            {formatDate(c.appointmentCreatedAt)}
          </TableCell>
          {/* {roleName === "branch" && (
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index)}
                checked={checkedStates[index] || true}
                label="Active"
              />
            </TableCell>
          )} */}
          <TableCell align="left">
            {/* {roleName === "branch" && (
              <>
                {" "}
                <img
                  src={edit}
                  alt="edit"
                  className="blue-c action-icon cursor"
                  onClick={() => handleUpdate(c)}
                />
                <img
                  src={dele}
                  alt="delete"
                  className="delete-icon cursor action-icon ms-2"
                  onClick={() => deleteBranches(true, c.customersId)}
                />
              </>
            )} */}
            <img
              src={eye}
              alt="view"
              className="delete-icon cursor action-icon ms-2"
              onClick={() => handleView(c.customersId)}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default TableLists;
